/*eslint-disable*/
import React, { useState } from 'react'
import {
  Button,
  ButtonsContainer,
  ItemsPickContainer,
  Flex,
  H2,
  SelectedItemsContainer,
  TabFooter,
  Title,
  Animation,
  TabSubcontainer,
} from '../../styling/GlobalStyles'
import { Input } from '../../components/Input/Input'
import { CancelBtn } from 'components/Button/CancelBtn'
import { AddOrangeBtn } from 'components/Button/AddOrangeBtn'
import { CheckBox } from 'components/CheckBox/CheckBox'
import { toast } from 'react-toastify'
import { SelectedItem } from 'components/ItemsPick/SelectedItem'
import { IContract, IContractShiftsState, IEmployeesTab } from 'types/users.interface'
import { v4 } from 'uuid'
import { checkInvalid, convertToDate } from 'utils/helpers'
import { standardFieldValidation, validateDate } from 'utils/validationUtils'
import { ContractInputWrapper, ContractShiftsContainer, ShiftListItem } from './Employees.styled'
import { contractTypes, days, employeeContractInputs, shiftChangeTypes } from './employeesData'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { IGetWorkScheduleModel } from 'types/api/shiftsApi.interface'
import { ChipsContainer } from 'components/CheckBox/CheckBox.styled'
import { CheckChip } from 'components/CheckBox/CheckChip'
import { Collapsable } from 'components/Collapsable/Collapsable'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { IContractShift, ILogisticsInfo } from 'types/api/usersApi.interface'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { logisticsTransportationTypes } from './employeesData'
import { tierOptions } from 'pages/Accomodation/Sections/CheckIn'

export const EmployeesContractsTab = ({ handleSubmit, state, setState }: IEmployeesTab) => {
  const [selectedContract, setSelectedContract] = useState<IContract & { logisticsInfo?: ILogisticsInfo }>(null)
  const isEditing = location.pathname.includes('edit')
  const [invalidFields, setInvalidFields] = useState<string[]>([])
  const [selectedShift, setSelectedShift] = useState<ISelectValue>(null)
  const [selectedMealType, setSelectedMealType] = useState<ISelectValue>(null)
  const [shiftsState, setShiftsState] = useState<IContractShiftsState>({
    freeDays: [],
    workScheduleModelId: null,
    shifts: [],
    shiftChangeType: null,
    shiftChangeInterval: null,
    vacationDays: null
  })
  const [logisticsState, setLogisticsState] = useState<ILogisticsInfo>({
    hasFoodProvided: false,
    hasFoodAllowance: false,
    foodAllowanceInCompanyAmount: null,
    foodAllowanceOutCompanyAmount: null,
    hasAccommodationProvided: false,
    hasAccommodationAllowance: false,
    accomodationTierPolicy: null,
    accomodationAllowanceInCompanyAmount: null,
    accomodationAllowanceOutCompanyAmount: null,
    transportationType: 1,
    hasTransportationAllowance: false,
    transportationAllowanceInCompanyAmount: null,
    transportationAllowanceOutCompanyAmount: null,
    hasResponsibilityAllowance: false,
    responsibilityAllowanceInCompanyAmount: null,
    responsibilityAllowanceOutCompanyAmount: null,
    hasExtraDutyAllowance: false,
    extraDutyAllowanceInCompanyAmount: null,
    extraDutyAllowanceOutCompanyAmount: null,
  })

  console.log(selectedContract)


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    standardFieldValidation(e, setInvalidFields)
    setSelectedContract((prev) => {
      const copy = { ...prev }
      copy[name] = Number(value)
      return copy
    })
  }

  const handleSelectForShifts = (v: any, n: string) => {
    ///TODO: Srediti tipove, ovaj workScheduleModelId nema u selectedContract a mislim  da ga u objektu ima ima, proveriti
    if (n == 'shiftChangeType' && !shiftsState.workScheduleModelId?.value) {
      toast.warn('Work schedule model must be selected before selecting shift change type')
      return
    }

    setShiftsState(prev => ({ ...prev, [n]: v, shiftChangeInterval: n == 'workScheduleModelId' ? null : prev.shiftChangeInterval }))
  }

  const handleChangeForShifts = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setShiftsState((prev) => {
      const copy = { ...prev }
      copy[name] = Number(value)
      return copy
    })
  }

  const checkValid = () => {

    if (invalidFields.length > 0) {
      return 'All contract fields must be valid'
    }

    if (!String(shiftsState.vacationDays)) {
      return 'Vacation days must be entered.'
    }

    if (!selectedContract?.contractIndefinite && new Date(selectedContract?.startDate).getTime() > new Date(selectedContract?.endDate).getTime()) {
      return 'Contract start date cannot be after or the same as the end date'
    }

    if (shiftsState.workScheduleModelId?.value && !shiftsState.shifts.length) {
      return 'One or more shifts must be added if the contract has work schedule model selected'
    }

    if (shiftsState.shiftChangeInterval > shiftsState.workScheduleModelId?.workDaysCount) {
      return 'Shift change interval cannot be greater thatn work days conunt of selected work schedule model'
    }

    if (shiftsState.shifts?.length > 2 && !shiftsState.shiftChangeType) {
      return 'Shift change type is required if there are 2 or more shifts selected'
    }

    if (shiftsState.shiftChangeType?.value == 4 && !shiftsState.shiftChangeInterval) {
      return 'Shift change interval is required if the selected shift change type is Manual'
    }

    // if(state.contracts.some(c=>c.endDate.getTime() > selectedContract.startDate.getTime() || c.startDate.getTime() < selectedContract.endDate()){
    //   resp = 'Contract with given time period already exists'
    // }  For future maybe
  }


  const handleDate = (e: Date, name: string) => {
    validateDate(name, setInvalidFields)
    setSelectedContract((prev) => {
      const copy = { ...prev }
      copy[name] = e
      if (name === 'startDate' && !copy.contractIndefinite && !copy.endDate) {
        const dt = new Date(e)
        copy.endDate = new Date(dt.setMonth(dt.getMonth() + 6))
        setInvalidFields((prevF) => {
          let copyF = [...prevF]
          copyF = copyF.filter((f: string) => f !== 'endDate')
          return copyF
        })
      }
      return copy
    })
  }

  const addContract = () => {
    if (selectedContract) {
      const msg = checkValid()
      if (msg) {
        toast.error(msg)
        return
      }
      addSelectedToState()
      return
    }
    const contract = {
      startDate: new Date(),
      endDate: null,
      signed: false,
      contractIndefinite: false,
      id: v4(),
      type: 1,
      role: null,
      value: null,
      logisticsInfo: {
        hasFoodProvided: false,
        hasFoodAllowance: false,
        foodAllowanceInCompanyAmount: null,
        foodAllowanceOutCompanyAmount: null,
        hasAccommodationProvided: false,
        hasAccommodationAllowance: false,
        accomodationTierPolicy: null,
        accomodationAllowanceInCompanyAmount: null,
        accomodationAllowanceOutCompanyAmount: null,
        transportationType: null,
        hasTransportationAllowance: false,
        transportationAllowanceInCompanyAmount: null,
        transportationAllowanceOutCompanyAmount: null,
        hasResponsibilityAllowance: false,
        responsibilityAllowanceInCompanyAmount: null,
        responsibilityAllowanceOutCompanyAmount: null,
        hasExtraDutyAllowance: false,
        extraDutyAllowanceInCompanyAmount: null,
        extraDutyAllowanceOutCompanyAmount: null,
        foodDietaryPreferenceType: null,
        transportationTransferPoint: null,
      }
    }
    setState((prev) => {
      const copy = structuredClone(prev)
      copy.contracts.push(contract)
      return copy
    })
    setSelectedContract(contract)
    setInvalidFields(employeeContractInputs)
  }

  const handleCheck = () => {
    setSelectedContract((prev) => {
      const copy = { ...prev }
      copy.contractIndefinite = !copy.contractIndefinite
      if (copy.contractIndefinite) {
        copy.endDate = null
        setInvalidFields((prevF) => {
          let fieldsCopy = [...prevF]
          fieldsCopy = fieldsCopy.filter((f: string) => f !== 'endDate')
          return fieldsCopy
        })
      }
      return copy
    })
  }

  const addSelectedToState = () => {
    setState((prev) => {
      const copy = { ...prev }
      const index = state.contracts.findIndex((c: IContract) => c.id === selectedContract.id)
      //@ts-ignore TODO
      state.contracts[index] = { ...selectedContract, ...shiftsState, workScheduleModel: shiftsState.workScheduleModelId, logisticsInfo: logisticsState }
      return copy
    })
  }


  const handleCheckbox = (name: string) => {
    setSelectedContract(prev => ({ ...prev, [name]: !prev[name] }))
  }


  const handleSaveContract = (clearFields?: boolean) => {
    const msg = checkValid()
    if (msg) {
      toast.error(msg)
      return
    }
    if (selectedContract) {
      addSelectedToState()
      if (clearFields) {
        setSelectedContract(null)
        setSelectedMealType(null)
        setShiftsState({
          freeDays: [],
          workScheduleModelId: null,
          shifts: [],
          shiftChangeType: null,
          shiftChangeInterval: null,
          vacationDays: null
        })
        setLogisticsState({
          hasFoodProvided: false,
          hasFoodAllowance: false,
          foodAllowanceInCompanyAmount: null,
          foodAllowanceOutCompanyAmount: null,
          hasAccommodationProvided: false,
          hasAccommodationAllowance: false,
          accomodationTierPolicy: null,
          accomodationAllowanceInCompanyAmount: null,
          accomodationAllowanceOutCompanyAmount: null,
          transportationType: null,
          hasTransportationAllowance: false,
          transportationAllowanceInCompanyAmount: null,
          transportationAllowanceOutCompanyAmount: null,
          hasResponsibilityAllowance: false,
          responsibilityAllowanceInCompanyAmount: null,
          responsibilityAllowanceOutCompanyAmount: null,
          hasExtraDutyAllowance: false,
          extraDutyAllowanceInCompanyAmount: null,
          extraDutyAllowanceOutCompanyAmount: null,
        })

      }
    }
  }


  const handleSave = () => {
    if (selectedContract) {
      const msg = checkValid()
      if (msg) {
        toast.error(msg)
        return
      }
      addSelectedToState()
      handleSubmit()
    } else {
      handleSubmit()

    }
  }


  const handleSelectContract = (item: IContract) => {

    if (selectedContract) {
      return
    }

    handleSaveContract(false)
    setSelectedContract(item)
    setShiftsState({
      freeDays: item.freeDays || [],
      //@ts-ignore // TODO
      workScheduleModelId: { label: item.workScheduleModel?.name || item.workScheduleModel?.label, value: item.workScheduleModel?.id || item.workScheduleModel?.value, restDaysCount: item.workScheduleModel?.restDaysCount, isWeekModel: item.workScheduleModel?.isWeekModel, workDaysCount: item.workScheduleModel?.workDaysCount },
      //@ts-ignore // TODO
      shifts: item.shifts.map(s => ({ ...s, shiftId: s.shift?.id || s.shiftId, shiftName: s.shift?.name || s.shiftName })),
      //@ts-ignore // TODO
      shiftChangeType: shiftChangeTypes.find(t => t.value == item.shiftChangeType),
      shiftChangeInterval: item.shiftChangeInterval,
      vacationDays: item.vacationDays
    })
    //@ts-ignore // Handle both logisticsInfo and logisticsInfo for backward compatibility, and exclude foodDietaryPreferenceType
    const logisticsData = item.logisticsInfo || item.logisticsInfo
    if (logisticsData) {
      const { foodDietaryPreferenceType, ...logisticsWithoutDietary } = logisticsData as any
      setLogisticsState(logisticsWithoutDietary)
    } else {
      setLogisticsState({
        hasFoodProvided: false,
        hasFoodAllowance: false,
        foodAllowanceInCompanyAmount: null,
        foodAllowanceOutCompanyAmount: null,
        hasAccommodationProvided: false,
        hasAccommodationAllowance: false,
        accomodationAllowanceInCompanyAmount: null,
        accomodationAllowanceOutCompanyAmount: null,
        transportationType: null,
        accomodationTierPolicy: null,
        hasTransportationAllowance: false,
        transportationAllowanceInCompanyAmount: null,
        transportationAllowanceOutCompanyAmount: null,
        hasResponsibilityAllowance: false,
        responsibilityAllowanceInCompanyAmount: null,
        responsibilityAllowanceOutCompanyAmount: null,
        hasExtraDutyAllowance: false,
        extraDutyAllowanceInCompanyAmount: null,
        extraDutyAllowanceOutCompanyAmount: null,
      })
    }
  }

  const handleRemove = () => {
    setInvalidFields([])
    setSelectedContract(null)
    setSelectedMealType(null)
    setShiftsState({
      freeDays: [],
      workScheduleModelId: null,
      shifts: [],
      shiftChangeType: null,
      shiftChangeInterval: null,
      vacationDays: null,
    })
    setLogisticsState({
      hasFoodProvided: false,
      hasFoodAllowance: false,
      foodAllowanceInCompanyAmount: null,
      foodAllowanceOutCompanyAmount: null,
      hasAccommodationProvided: false,
      hasAccommodationAllowance: false,
      accomodationAllowanceInCompanyAmount: null,
      accomodationAllowanceOutCompanyAmount: null,
      transportationType: null,
      accomodationTierPolicy: null,
      hasTransportationAllowance: false,
      transportationAllowanceInCompanyAmount: null,
      transportationAllowanceOutCompanyAmount: null,
      hasResponsibilityAllowance: false,
      responsibilityAllowanceInCompanyAmount: null,
      responsibilityAllowanceOutCompanyAmount: null,
      hasExtraDutyAllowance: false,
      extraDutyAllowanceInCompanyAmount: null,
      extraDutyAllowanceOutCompanyAmount: null,
    })
  }

  const handleSelect = (v: ISelectValue, name: string) => {
    setSelectedContract(prev => {
      const copy = structuredClone(prev)
      copy[name] = v.value
      return copy
    })
  }


  const parse = (data: any) => {
    return data.data.map((item) => ({ label: item.name, value: item.id }))
  }

  const parseWorkScheduleModel = (data: any) => {
    return data.data.map((item: IGetWorkScheduleModel) => ({ label: item.name, value: item.id, isWeekModel: item.isWeekModel, restDaysCount: item.restDaysCount, workDaysCount: item.workDaysCount }))
  }

  const handleFreeDays = (d: number) => {
    setShiftsState(prev => ({ ...prev, freeDays: prev.freeDays.includes(d) ? prev.freeDays.filter(fd => fd !== d) : shiftsState.workScheduleModelId.restDaysCount >= prev.freeDays.length + 1 ? [...prev.freeDays, d] : prev.freeDays }))
  }


  const addShift = () => {
    if (selectedShift) {
      setShiftsState(prev => ({ ...prev, shifts: [...prev.shifts, { shiftId: selectedShift.value, order: prev.shifts.length + 1, shiftName: selectedShift.label }] }))
      setSelectedShift(null)
    }
  }

  const removeShift = (s: IContractShift) => {
    setShiftsState(prev => ({ ...prev, shifts: prev.shifts.filter(sh => sh.shiftId !== s.shiftId).map((sh, i) => ({ ...sh, order: (i + 1) })) }))
  }

  const handleVacationDays = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShiftsState(prev => ({ ...prev, vacationDays: e.target.valueAsNumber }))

  }

  // Welfare handlers
  const handleWelfareCheckbox = (name: string, fieldsToReset?: string[]) => {
    setLogisticsState(prev => {
      const copy = { ...prev }
      if (fieldsToReset) {
        fieldsToReset.forEach(f => {
          copy[f] = null
        })
      }
      copy[name] = !copy[name]
      return copy
    })
  }

  const handleWelfareSelect = (v: ISelectValue, n: string) => {
    setLogisticsState(prev => ({ ...prev, [n]: v.value }))
  }

  const handleWelfareChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { valueAsNumber, name } = e.target
    standardFieldValidation(e, setInvalidFields, true)
    setLogisticsState(prev => ({ ...prev, [name]: valueAsNumber }))
  }

  // const addMealType = () => {
  //   if (selectedMealType) {
  //     setLogisticsState(prev => ({ ...prev, mealTypes: [...(prev.mealTypes || []), selectedMealType] }))
  //     setSelectedMealType(null)
  //   }
  // }

  // const removeMealType = (id: number) => {
  //   setLogisticsState(prev => ({ ...prev, mealTypes: prev.mealTypes.filter(m => m.value !== id) }))
  // }


  const parseRoles = (data: any) => {
    return data.data.map((item: any) => ({ label: item.name, value: item.id }))
  }


  return (
    <Animation>
      <ItemsPickContainer  >
        <SelectedItemsContainer>
          <Flex between mb='15'>
            <Title pad='0 20px'>Contracts</Title>
            <AddOrangeBtn onClick={addContract} />
          </Flex>
          {state?.contracts.map((item: IContract, i: number) => (
            <SelectedItem
              onClick={() => handleSelectContract({ ...item, name: i + 1 })}
              onRemove={handleRemove}
              setState={setState}
              key={item.id}
              data={{ ...item, name: 'Contract ' + convertToDate(item.startDate) }}
              type='contracts'
            />
          ))}
        </SelectedItemsContainer>
        <TabSubcontainer>

          {selectedContract &&
            state.contracts.some((c: IContract) => c.id === selectedContract?.id) ? (
            <ContractInputWrapper>
              <H2>Contract {convertToDate(selectedContract.startDate)}</H2>
              <Collapsable defaultOpen={true} text='Contract Details' >
                <CalendarInput
                  onChange={handleDate}
                  name='startDate'
                  labelText='Contract Start'
                  maxDate={selectedContract?.endDate ? new Date(selectedContract.endDate) : null}
                  defaultValue={
                    !isEditing || (isEditing && !selectedContract?.startDate)
                      ? selectedContract?.startDate
                      : new Date(selectedContract?.startDate.toString())
                  }
                />

                {selectedContract?.contractIndefinite ? null : (
                  <CalendarInput
                    onChange={handleDate}
                    name='endDate'
                    labelText='Contract Duration'
                    defaultValue={
                      selectedContract?.endDate ? new Date(selectedContract?.endDate?.toString()) : null
                    }
                  />
                )}
                <CheckBox
                  state={selectedContract.contractIndefinite}
                  onClick={handleCheck}
                  title='Contract indefinite'
                />
                <HonestSelectInput
                  options={contractTypes}
                  onChange={handleSelect}
                  defaultValue={selectedContract.type}
                  name='type'
                  labelText='Contract type'
                />
                <HonestSelectAsyncInput
                  link='roles'
                  placeholder='Search role'
                  name='roleId'
                  labelText='Role'
                  defaultValue={selectedContract?.role?.label}
                  onChange={(v: ISelectValue) => setSelectedContract(prev => ({ ...prev, role: v }))}
                  parserFunction={parseRoles}
                />
                <Input
                  type='number'
                  labelText='Amount'
                  name='value'
                  value={selectedContract?.value}
                  onChange={handleChange}
                  placeholder='Enter amount'
                  invalid={checkInvalid(invalidFields, 'value')}
                />
                <CheckBox state={selectedContract.shouldPayOvertime} onClick={() => handleCheckbox('shouldPayOvertime')} square title='Overtime should be paid' />

              </Collapsable>
              <Collapsable text='Work Schedule' >
                <ContractShiftsContainer>
                  <Input name='vacationDays' allowZero placeholder='15' labelText='Vacation Days' type='number' value={shiftsState.vacationDays} onChange={handleVacationDays} invalid={!String(shiftsState.vacationDays)} />
                  <HonestSelectAsyncInput
                    name='workScheduleModelId'
                    labelText='Work Schedule Model'
                    onChange={handleSelectForShifts}
                    placeholder='Select model'
                    link='work-schedule/model'
                    parserFunction={parseWorkScheduleModel}
                    // @ts-ignore
                    defaultValue={shiftsState.workScheduleModelId?.label || shiftsState?.workScheduleModel?.label}
                    nomarg
                  />
                  <CalendarInput
                    onChange={handleDate}
                    name='workScheduleIntervalStartDate'
                    labelText='Schedule Cycle Start Date'
                    maxDate={selectedContract?.endDate ? new Date(selectedContract.endDate) : null}
                    minDate={selectedContract?.startDate ? new Date(selectedContract.startDate) : null}
                    defaultValue={
                      !isEditing || (isEditing && !selectedContract?.workScheduleIntervalStartDate)
                        ? selectedContract?.workScheduleIntervalStartDate
                        : new Date(selectedContract?.workScheduleIntervalStartDate.toString())
                    }
                  />
                  {shiftsState.workScheduleModelId?.isWeekModel && <Flex column gap='1rem' >
                    <BodyText weight='bold' >Free Days</BodyText>
                    <ChipsContainer>
                      {days.map(d => <CheckChip active={shiftsState.freeDays?.includes(d.value)} onClick={() => handleFreeDays(d.value)} text={d.label} />)}
                    </ChipsContainer>
                  </Flex>}
                  <BodyText weight='bold' >Shifts</BodyText>
                  <Flex width='100%' gap='2rem' alignEnd >
                    <HonestSelectAsyncInput
                      name='shift'
                      labelText='Shift'
                      onChange={v => setSelectedShift(v)}
                      placeholder='Select shift'
                      link='shifts'
                      parserFunction={parse}
                      defaultValue={selectedShift?.label}
                      nomarg
                    />
                    <Button orange onClick={addShift}>
                      Add
                    </Button>
                  </Flex>

                  <Flex column gap='1rem'  >
                    {shiftsState.shifts.map(s => <ShiftListItem>
                      <Flex width='100%' between ><Flex gap='1rem' ><TitleText weight='bold' >{s.order}</TitleText><BodyText>{s.shiftName}</BodyText></Flex><CloseIcon onClick={() => removeShift(s)} /></Flex>
                    </ShiftListItem>)}
                  </Flex>
                  {shiftsState.shifts.length >= 2 && <Flex column gap='1rem' width='100%' >
                    <HonestSelectInput name='shiftChangeType' labelText='Shift Change Type' onChange={handleSelectForShifts} options={shiftChangeTypes} defaultValue={shiftsState?.shiftChangeType?.value} />
                    {shiftsState.shiftChangeType?.label == 'Manual' && shiftsState?.workScheduleModelId?.label && <Input
                      type='number'
                      labelText='Shift Change Interval'
                      name='shiftChangeInterval'
                      value={shiftsState.shiftChangeInterval}
                      max={shiftsState.workScheduleModelId.workDaysCount}
                      nomarg
                      onChange={handleChangeForShifts}
                      placeholder={'Maximum: ' + shiftsState.workScheduleModelId?.workDaysCount}
                    />}
                  </Flex>}
                </ContractShiftsContainer>
              </Collapsable>
              <Collapsable text='Welfare' >
                <Flex padding='1rem' width='100%' container column gap='1rem'  >
                  <TitleText weight='bold' >Food</TitleText>
                  <CheckBox state={logisticsState?.hasFoodProvided} onClick={() => handleWelfareCheckbox('hasFoodProvided')} square title='Include Food' />
                  <CheckBox state={logisticsState?.hasFoodAllowance} onClick={() => handleWelfareCheckbox('hasFoodAllowance', ['foodAllowanceInCompanyAmount', 'foodAllowanceOutCompanyAmount'])} square title='Food Allowance' />
                  {logisticsState?.hasFoodAllowance && <>
                    <Input allowZero name='foodAllowanceInCompanyAmount' onChange={handleWelfareChange} type='number' value={logisticsState?.foodAllowanceInCompanyAmount} labelText='Food Allowance (Internal)' placeholder='1500' nomarg />
                    <Input allowZero name='foodAllowanceOutCompanyAmount' onChange={handleWelfareChange} type='number' value={logisticsState?.foodAllowanceOutCompanyAmount} labelText='Food Allowance (External)' placeholder='500' nomarg />
                  </>}
                  {logisticsState?.hasFoodProvided && <>
                    {/* <HonestSelectAsyncInput
                      name='foodMealSupplier'
                      labelText='Meal Supplier'
                      onChange={handleWelfareSelect}
                      placeholder='Select Meal Supplier'
                      link='food/management/meal/supplier'
                      parserFunction={parse}
                      defaultValue={logisticsState?.foodMealSupplier?.label || null}
                      nomarg
                    /> */}
                    {/* <Flex width='100%' gap='2rem' alignEnd >
                      <HonestSelectAsyncInput
                        name='mealTypes'
                        labelText='Meal Types'
                        onChange={v => setSelectedMealType(v)}
                        placeholder='Select Meal Type'
                        link='food/management/meal/type'
                        parserFunction={parse}
                        defaultValue={selectedMealType?.label}
                        nomarg
                      />
                      <Button disabled={!selectedMealType?.value} orange onClick={addMealType}>
                        Add
                      </Button>
                    </Flex> */}
                    {/* <Flex column gap='5px' >
                      <OtherText>Selected Meal Types:</OtherText>
                      {logisticsState?.mealTypes?.map(m => <StyledContainer key={m.value} style={{ padding: 5 }} height='auto' width='100%' >
                        <Flex between center >
                          <BodyText>{m.label}</BodyText>
                          <CloseIcon onClick={() => removeMealType(m.value)} />
                        </Flex>
                      </StyledContainer>
                      )}
                    </Flex> */}
                  </>}
                </Flex>
                <Flex padding='1rem' width='100%' container column gap='1rem'  >
                  <TitleText weight='bold' >Accommodation</TitleText>
                  <CheckBox state={logisticsState?.hasAccommodationProvided} onClick={() => handleWelfareCheckbox('hasAccommodationProvided')} square title='Include Accommodation' />
                  <CheckBox state={logisticsState?.hasAccommodationAllowance} onClick={() => handleWelfareCheckbox('hasAccommodationAllowance', ['accomodationAllowanceInCompanyAmount', 'accomodationAllowanceOutCompanyAmount'])} square title='Accommodation Allowance' />
                  {logisticsState?.hasAccommodationAllowance && <>
                    <Input allowZero name='accomodationAllowanceInCompanyAmount' onChange={handleWelfareChange} type='number' value={logisticsState?.accomodationAllowanceInCompanyAmount} labelText='Accommodation Allowance (Internal)' placeholder='1500' nomarg />
                    <Input allowZero name='accomodationAllowanceOutCompanyAmount' onChange={handleWelfareChange} type='number' value={logisticsState?.accomodationAllowanceOutCompanyAmount} labelText='Accommodation Allowance (External)' placeholder='500' nomarg />
                  </>}
                  <HonestSelectInput options={tierOptions} labelText='Accommodation Tier' name='accomodationTierPolicy' defaultValue={logisticsState?.accomodationTierPolicy} onChange={handleWelfareSelect} nomarg />

                </Flex>
                <Flex padding='1rem' width='100%' container column gap='1rem'  >
                  <TitleText weight='bold' >Transportation</TitleText>
                  <HonestSelectInput options={logisticsTransportationTypes} labelText='Transport Type' name='transportationType' defaultValue={logisticsState?.transportationType} onChange={handleWelfareSelect} nomarg />
                  {/* {logisticsState?.transportationType?.value == 2 && <HonestSelectInput
                    name='transportationVehicleType'
                    labelText='Vehicle Type'
                    onChange={handleWelfareSelect}
                    placeholder='Select Transportation Vehicle Type'
                    options={transportationVehicleTypes}
                    defaultValue={logisticsState?.transportationVehicleType?.value}
                    nomarg
                  />} */}
                  {/* {logisticsState?.transportationType?.value == 2 && <HonestSelectAsyncInput
                    name='transportationTransferPoint'
                    labelText='Transportation Point'
                    onChange={handleWelfareSelect}
                    placeholder='Select Transportation Point'
                    link='transportation/management/transfer-point'
                    parserFunction={parse}
                    defaultValue={logisticsState?.transportationTransferPoint?.label}
                    nomarg
                  />} */}
                  <CheckBox state={logisticsState?.hasTransportationAllowance} onClick={() => handleWelfareCheckbox('hasTransportationAllowance', ['transportationAllowanceInCompanyAmount', 'transportationAllowanceOutCompanyAmount'])} square title='Transport Allowance' />
                  {logisticsState?.hasTransportationAllowance && <>
                    <Input allowZero name='transportationAllowanceInCompanyAmount' onChange={handleWelfareChange} type='number' value={logisticsState?.transportationAllowanceInCompanyAmount} labelText='Transport Allowance (Internal)' placeholder='1500' nomarg />
                    <Input allowZero name='transportationAllowanceOutCompanyAmount' onChange={handleWelfareChange} type='number' value={logisticsState?.transportationAllowanceOutCompanyAmount} labelText='Transport Allowance (External)' placeholder='500' nomarg />
                  </>}
                </Flex>
                <Flex padding='1rem' width='100%' container column gap='1rem'  >
                  <TitleText weight='bold' >Responsibility and Extra Duty Allowance</TitleText>
                  <CheckBox state={logisticsState?.hasResponsibilityAllowance} onClick={() => handleWelfareCheckbox('hasResponsibilityAllowance', ['responsibilityAllowanceInCompanyAmount', 'responsibilityAllowanceOutCompanyAmount'])} square title='Include Responsibility Allowance' />
                  {logisticsState?.hasResponsibilityAllowance && <>
                    <Input allowZero name='responsibilityAllowanceInCompanyAmount' onChange={handleWelfareChange} type='number' value={logisticsState?.responsibilityAllowanceInCompanyAmount} labelText='Responsibility Allowance (Internal)' placeholder='1500' nomarg />
                    <Input allowZero name='responsibilityAllowanceOutCompanyAmount' onChange={handleWelfareChange} type='number' value={logisticsState?.responsibilityAllowanceOutCompanyAmount} labelText='Responsibility Allowance (External)' placeholder='500' nomarg />
                  </>}
                  <CheckBox state={logisticsState?.hasExtraDutyAllowance} onClick={() => handleWelfareCheckbox('hasExtraDutyAllowance', ['extraDutyAllowanceInCompanyAmount', 'extraDutyAllowanceOutCompanyAmount'])} square title='Include Extra Duty Allowance' />
                  {logisticsState?.hasExtraDutyAllowance && <>
                    <Input allowZero name='extraDutyAllowanceInCompanyAmount' onChange={handleWelfareChange} type='number' value={logisticsState?.extraDutyAllowanceInCompanyAmount} labelText='Extra Duty Allowance (Internal)' placeholder='1500' nomarg />
                    <Input allowZero name='extraDutyAllowanceOutCompanyAmount' onChange={handleWelfareChange} type='number' value={logisticsState?.extraDutyAllowanceOutCompanyAmount} labelText='Extra Duty Allowance (External)' placeholder='500' nomarg />
                  </>}
                </Flex>
              </Collapsable>
              <Button orange onClick={() => handleSaveContract(true)}>
                Save
              </Button>
            </ContractInputWrapper>
          ) : (
            <Flex width='100%' center column gap='1rem' minHeight='100%' justcenter>
              <H2>No Contract selected</H2>
              <Button onClick={addContract} orange>
                Add new
              </Button>
            </Flex>
          )}
        </TabSubcontainer>
      </ItemsPickContainer>
      <TabFooter  >
        <ButtonsContainer>
          <CancelBtn />
          <Button orange onClick={handleSave}>
            Save
          </Button>
        </ButtonsContainer>
      </TabFooter>
    </Animation>
  )
}
